export default __webpack_public_path__ + "static/media/arco-ajuda.45324cf1.webp";